import { Injectable } from '@angular/core';
import { CompetitionDTO, CompetitionsService } from 'dev-corize-api-client';
import { CompetitionsGetRequestParams, CompetitionDTOApiListResponse } from 'dev-corize-api-client';
import { ToastService } from './services/toastr-service';
 

@Injectable({
  providedIn: 'root'
})
export class CorizeUiLibService {

  constructor(protected competitionsService:CompetitionsService, protected toastService:ToastService) { }
  
  public getCompetitions(limit:number, offset:number, total:number): Promise<Array<CompetitionDTO>> {
    return new Promise((resolve, reject) => {
      var t = this;
      var req: CompetitionsGetRequestParams = {
        limit: limit,
        offset: offset,
        total: total
      };

      t.competitionsService.competitionsGet(req).subscribe(
        (ret: CompetitionDTOApiListResponse) => {
          resolve(ret.data);
        },
        (err) => {
          t.toastService.showError(err);
          reject();
        },
        () => {
        });
    }) 
  }
}
